import { API_BASE, parseErrorBody, storeAuthSession } from './client.js';
import { showToast } from '../lib/toastStore.js';

function normalizeLoginArgs(usernameOrPayload, password, realm) {
  if (usernameOrPayload && typeof usernameOrPayload === 'object') {
    return {
      username: usernameOrPayload.username,
      password: usernameOrPayload.password,
      remember: usernameOrPayload.remember !== false,
      realm,
    };
  }
  return { username: usernameOrPayload, password, remember: true, realm };
}

export async function login(usernameOrPayload, password, realm = 'admin') {
  const payload = normalizeLoginArgs(usernameOrPayload, password, realm);
  const res = await fetch(`${API_BASE}/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      username: String(payload.username || '').trim(),
      password: payload.password || '',
    }),
  });
  if (!res.ok) {
    const msg = await parseErrorBody(res).catch(() => 'Login failed');
    const errMsg = msg || 'Login failed';
    showToast(errMsg, 'error');
    throw new Error(errMsg);
  }
  const data = await res.json();
  const role = data?.role || payload.realm || 'admin';
  storeAuthSession(data, { remember: payload.remember, realm: role });
  return data;
}
